import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAppSelector, useAppDispatch } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import { updateCreditDetails } from '@app/store/slices/authSlice';

const useCreditDetails = () => {
  const dispatch = useAppDispatch();
  const creditId = useAppSelector((state) => state.auth.userDetails?.linkedCredits[0]?.creditId);
  const creditInfo = useAppSelector((state) => state.auth.creditDetails);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCreditDetails = async () => {
    if (!creditId) return;
    
    setIsLoading(true);
    try {
      const url = endpoints.creditInfo + creditId;
      const res = await axios.get(url);
      dispatch(updateCreditDetails(res?.data ?? {}));
    } catch (err) {
      console.log('fetchCreditDetails', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (creditId && (!creditInfo || Object.keys(creditInfo).length === 0 || creditInfo.availableCreditAmount === undefined)) {
      fetchCreditDetails();
    }
  }, [creditId]);

  return {
    creditInfo,
    isLoading,
  };
};

export default useCreditDetails;